/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Menu } from '../../models/menu';

export interface ApiMasterMenuGetAllGet$Params {
}

export function apiMasterMenuGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterMenuGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Menu>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterMenuGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Menu>>;
    })
  );
}

apiMasterMenuGetAllGet.PATH = '/api/Master/Menu/GetAll';
